/**
 * List Schema of CargaAryzta
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaAryzta} from '@/model/resource/CargaAryzta'

/* TODO: review generated schema */
export class ListCargaAryztaSchema extends Schema {
  readonly name = 'ListCargaAryzta'

  readonly fieldSet: FieldSet<CargaAryzta> = {
    idcargaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    cgcEmissorNf: (): FieldComponent => ({
      is: Component.Render,
    }),
    serieNotaFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    danfe: (): FieldComponent => ({
      is: Component.Render,
    }),
    nrNotaFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    siglaCliente: (): FieldComponent => ({
      is: Component.Render,
    }),
    cepCliente: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataEmissaoNota: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataSaidaMerc: (): FieldComponent => ({
      is: Component.Render,
    }),
    tipoFrete: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeTransp: (): FieldComponent => ({
      is: Component.Render,
    }),
    codigoCfop: (): FieldComponent => ({
      is: Component.Render,
    }),
    denominacaoCfop: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
